import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives, vShow as _vShow, createElementVNode as _createElementVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "columns-nav" }
const _hoisted_2 = { class: "group-columns--dropdown" }
const _hoisted_3 = {
  key: 0,
  class: "column"
}
const _hoisted_4 = { class: "column group-select--container" }
const _hoisted_5 = { class: "column entry-column__scroll--container" }
const _hoisted_6 = {
  key: 1,
  class: "column-content-placeholder"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_list = _resolveComponent("q-list")!
  const _component_q_menu = _resolveComponent("q-menu")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_select_header = _resolveComponent("select-header")!
  const _component_entry_column = _resolveComponent("entry-column")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives(_createElementVNode("div", _hoisted_1, [
      _createVNode(_component_q_btn, {
        class: "group_filter_selection",
        "icon-right": "expand_more",
        size: "md",
        color: "primary",
        flat: "",
        label: _ctx.activeGroup,
        options: _ctx.columns,
        "onUpdate:modelValue": _ctx.updateSelection,
        dense: "",
        rounded: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_q_menu, null, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedGroupKeys, (order) => {
                return (_openBlock(), _createBlock(_component_q_list, null, {
                  default: _withCtx(() => [
                    _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                      clickable: "",
                      onClick: ($event: any) => (_ctx.updateSelection(order))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_q_item_section, null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(order), 1)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1032, ["onClick"])), [
                      [_directive_close_popup]
                    ])
                  ]),
                  _: 2
                }, 1024))
              }), 256))
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["label", "options", "onUpdate:modelValue"])
    ], 512), [
      [_vShow, (_ctx.overviewPageWidth <= (_ctx.sortedGroupKeys.length * _ctx.orderContainerWidth)) && _ctx.sortedGroupKeys.length > 1 && _ctx.activeView !== _ctx.GroupView.Dropdown && (_ctx.columns?.filter(c => c.active)?.length !== _ctx.sortedGroupKeys.length)]
    ]),
    _createElementVNode("div", {
      class: "columns-container",
      style: _normalizeStyle(_ctx.width ? `width: ${_ctx.width}` : `min-width: ${_ctx.minWidth}px`)
    }, [
      _createElementVNode("div", _hoisted_2, [
        (_ctx.activeView === _ctx.GroupView.Dropdown)
          ? _renderSlot(_ctx.$slots, "content-dropdown", { key: 0 }, () => [
              (_ctx.groups && _ctx.sortedGroupKeys.length && _ctx.activeGroup)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, [
                      _createVNode(_component_select_header, {
                        class: "entry-column__select--container",
                        modelValue: _ctx.activeGroup,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.activeGroup) = $event)),
                        options: _ctx.sortedGroupKeys,
                        placeholder: "Select a Group",
                        "options-map": {value: true, subtitle: e => `${_ctx.groups[e.value]?.length || ''} items` },
                        description: `${_ctx.groups[_ctx.activeGroup]?.length} items in ${_ctx.activeGroup}`,
                        "onUpdate:selection": _cache[1] || (_cache[1] = e => _ctx.setActive(e.value))
                      }, null, 8, ["modelValue", "options", "options-map", "description"])
                    ]),
                    _createElementVNode("div", _hoisted_5, [
                      (Array.isArray(_ctx.groups[_ctx.activeGroup]))
                        ? (_openBlock(), _createBlock(_component_entry_column, {
                            ref: "activeColumn",
                            items: _ctx.groups[_ctx.activeGroup],
                            type: _ctx.type,
                            view: _ctx.itemView === 1 ? _ctx.ColumnView.Table : _ctx.columnView,
                            "item-view": _ctx.itemView,
                            key: `column-group-dropdown-${_ctx.activeGroup}`,
                            class: _normalizeClass(_ctx.classList),
                            "class-list": _ctx.classList,
                            selection: _ctx.selection,
                            "item-config": _ctx.itemConfig,
                            "min-width": _ctx.colMinWidth,
                            "max-width": _ctx.colMaxWidth,
                            width: _ctx.colWidth,
                            expandable: _ctx.expandable,
                            loading: _ctx.loading,
                            paginate: _ctx.paginate,
                            onAdd: _cache[2] || (_cache[2] = ($event: any) => (_ctx.emit('add', $event))),
                            onRemove: _cache[3] || (_cache[3] = ($event: any) => (_ctx.emit('remove', $event, _ctx.group))),
                            onActive: _cache[4] || (_cache[4] = ($event: any) => (_ctx.emit('active', $event, _ctx.group))),
                            onSelect: _cache[5] || (_cache[5] = ($event: any) => (_ctx.emit('select', $event, _ctx.group))),
                            onSearch: _cache[6] || (_cache[6] = ($event: any) => (_ctx.emit('search', $event, _ctx.group))),
                            onResolved: _cache[7] || (_cache[7] = ($event: any) => (_ctx.emit('resolved', $event, _ctx.group))),
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = e => _ctx.emit('update:modelValue', e))
                          }, {
                            "item-header": _withCtx(({entry, cache, expanded, elements, expand, actions, index}) => [
                              _renderSlot(_ctx.$slots, "group-item-header", {
                                column: _ctx.activeColumn,
                                entry: entry,
                                actions: actions,
                                elements: elements,
                                expand: expand,
                                cache: cache,
                                expanded: expanded,
                                itemIndex: index,
                                view: _ctx.activeView,
                                group: _ctx.activeGroup,
                                groupItems: _ctx.groups[_ctx.activeGroup],
                                groupIndex: _ctx.sortedGroupKeys.indexOf(_ctx.activeGroup)
                              }, undefined, true)
                            ]),
                            "item-content": _withCtx(({entry, cache, expanded, elements, expand, actions, index}) => [
                              _renderSlot(_ctx.$slots, "group-item-content", {
                                column: _ctx.activeColumn,
                                entry: entry,
                                actions: actions,
                                elements: elements,
                                expand: expand,
                                cache: cache,
                                expanded: expanded,
                                itemIndex: index,
                                view: _ctx.activeView,
                                group: _ctx.activeGroup,
                                groupItems: _ctx.groups[_ctx.activeGroup],
                                groupIndex: _ctx.sortedGroupKeys.indexOf(_ctx.activeGroup)
                              }, undefined, true)
                            ]),
                            "item-editor": _withCtx(({entry, cache, expanded, elements, expand, actions, index}) => [
                              _renderSlot(_ctx.$slots, "group-item-editor", {
                                column: _ctx.activeColumn,
                                entry: entry,
                                actions: actions,
                                elements: elements,
                                expand: expand,
                                cache: cache,
                                expanded: expanded,
                                itemIndex: index,
                                view: _ctx.activeView,
                                group: _ctx.activeGroup,
                                groupItems: _ctx.groups[_ctx.activeGroup],
                                groupIndex: _ctx.sortedGroupKeys.indexOf(_ctx.activeGroup)
                              }, undefined, true)
                            ]),
                            _: 3
                          }, 8, ["items", "type", "view", "item-view", "class", "class-list", "selection", "item-config", "min-width", "max-width", "width", "expandable", "loading", "paginate"]))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                : _createCommentVNode("", true),
              (!_ctx.activeGroup || (_ctx.groups && _ctx.groups[_ctx.activeGroup] && !_ctx.groups[_ctx.activeGroup].length))
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _renderSlot(_ctx.$slots, "placeholder", {}, undefined, true)
                  ]))
                : _createCommentVNode("", true)
            ], true)
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", {
        class: "group-columns--vertical hide-scrollbars",
        ref: "columnsContainer",
        style: _normalizeStyle({maxHeight: `calc(100vh - ${_ctx.columnsContainerOffset}px)`})
      }, [
        (_ctx.activeView === _ctx.GroupView.Vertical)
          ? _renderSlot(_ctx.$slots, "content-vertical", { key: 0 }, () => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedGroupKeys, (group, i) => {
                return (_openBlock(), _createElementBlock(_Fragment, null, [
                  (_ctx.groups && _ctx.sortedGroupKeys.length && Array.isArray(_ctx.groups[group]))
                    ? (_openBlock(), _createBlock(_component_entry_column, {
                        ref_for: true,
                        ref: e => _ctx.addColumnRef(group, e),
                        items: _ctx.groups[group],
                        type: _ctx.type,
                        name: group,
                        view: _ctx.columnView,
                        key: `column-group-${group}-${i}`,
                        class: _normalizeClass(_ctx.classList),
                        "class-list": _ctx.classList,
                        selection: _ctx.selection,
                        "item-config": _ctx.itemConfig,
                        "item-view": _ctx.itemView,
                        "min-width": _ctx.colMinWidth,
                        "max-width": _ctx.colMaxWidth,
                        width: _ctx.colWidth,
                        expandable: _ctx.expandable,
                        loading: _ctx.loading,
                        paginate: _ctx.paginate,
                        onAdd: _cache[9] || (_cache[9] = ($event: any) => (_ctx.emit('add', $event))),
                        onRemove: ($event: any) => (_ctx.emit('remove', $event, group)),
                        onActive: ($event: any) => (_ctx.emit('active', $event, group)),
                        onSelect: ($event: any) => (_ctx.emit('select', $event, group)),
                        onSearch: ($event: any) => (_ctx.emit('search', $event, group)),
                        onResolved: ($event: any) => (_ctx.emit('resolved', $event, group)),
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = e => _ctx.emit('update:modelValue', e))
                      }, {
                        "item-header": _withCtx(({entry, cache, expanded, elements, expand, actions, header, index}) => [
                          _renderSlot(_ctx.$slots, "group-item-header", {
                            entry: entry,
                            actions: actions,
                            elements: elements,
                            expand: expand,
                            cache: cache,
                            expanded: expanded,
                            view: _ctx.activeView,
                            group: header,
                            groupItems: _ctx.groups[group],
                            itemIndex: index,
                            groupIndex: i
                          }, undefined, true)
                        ]),
                        "item-metadata": _withCtx(({entry, cache, expanded, elements, expand, actions, header, index}) => [
                          _renderSlot(_ctx.$slots, "group-item-metadata", {
                            entry: entry,
                            actions: actions,
                            elements: elements,
                            expand: expand,
                            cache: cache,
                            expanded: expanded,
                            view: _ctx.activeView,
                            group: header,
                            groupItems: _ctx.groups[group],
                            itemIndex: index,
                            groupIndex: i
                          }, undefined, true)
                        ]),
                        "item-content": _withCtx(({entry, cache, expanded, elements, expand, actions, header, index}) => [
                          _renderSlot(_ctx.$slots, "group-item-content", {
                            entry: entry,
                            actions: actions,
                            elements: elements,
                            expand: expand,
                            cache: cache,
                            expanded: expanded,
                            view: _ctx.activeView,
                            group: header,
                            groupItems: _ctx.groups[group],
                            itemIndex: index,
                            groupIndex: i
                          }, undefined, true)
                        ]),
                        "item-editor": _withCtx(({entry, cache, expanded, elements, expand, actions, header, index}) => [
                          _renderSlot(_ctx.$slots, "group-item-editor", {
                            entry: entry,
                            actions: actions,
                            elements: elements,
                            expand: expand,
                            cache: cache,
                            expanded: expanded,
                            view: _ctx.activeView,
                            group: header,
                            groupItems: _ctx.groups[group],
                            itemIndex: index,
                            groupIndex: i
                          }, undefined, true)
                        ]),
                        _: 2
                      }, 1032, ["items", "type", "name", "view", "class", "class-list", "selection", "item-config", "item-view", "min-width", "max-width", "width", "expandable", "loading", "paginate", "onRemove", "onActive", "onSelect", "onSearch", "onResolved"]))
                    : _createCommentVNode("", true)
                ], 64))
              }), 256))
            ], true)
          : _createCommentVNode("", true)
      ], 4)
    ], 4)
  ], 64))
}